import { useProductsTFunction } from '@retail/products/i18n';
import { Typography } from '@mui/material';

interface Props {
  value?: number;
}

export const EmissionTypography = ({ value }: Props) => {
  const t = useProductsTFunction();

  const formatter = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 4,
  });
  const formattedTotalEmissionsValue = value != null ? formatter.format(value) : '-';

  return (
    <Typography variant="h4" color="grey.800">
      {formattedTotalEmissionsValue} {t('products.mgItem.supplierItem.kilo')}
    </Typography>
  );
};
